import { getPropertyTypeLabel } from '@miq/utils';
import { PropertySetStatisticalRendererComponent } from './property-set-statistical-renderer.component';
import { DataType } from '@miq/catalog';

export function countUsersAndGroups(inputData) {
  const data = inputData?.permissions || [];

  const { userCount, groupCount } = data.reduce(
    (counts, item) => {
      if (item.type === 'User') {
        counts.userCount++;
      } else if (item.type === 'Group') {
        counts.groupCount++;
      }
      return counts;
    },
    { userCount: 0, groupCount: 0 }
  );

  const result = [];
  if (userCount > 0) {
    result.push(`${userCount} ${userCount === 1 ? 'User' : 'Users'}`);
  }
  if (groupCount > 0) {
    result.push(`${groupCount} ${groupCount === 1 ? 'Group' : 'Groups'}`);
  }

  return result.join(', ');
}

/**
 * Returns given value in lowercase or empty string if value is null or undefined.
 * @param value
 * @returns
 */
const toLowerCaseOrEmpty = (value: string) => value?.toLowerCase() ?? '';

export const COLUMNS = [
  {
    columnId: 1,
    CellRenderer: PropertySetStatisticalRendererComponent,
    header: '',
    field: 'is_statistical',
  },
  {
    columnId: 2,
    header: 'Name',
    field: 'name',
    sortable: true,
    dataType: DataType.Text,
    // To be used by the cbre-table component
    sortDataTransformerFn: toLowerCaseOrEmpty,
    rowColumnTooltip: data => `Select ${data.name}`,
  },
  { columnId: 3, header: '# Records', field: 'no_of_records', sortable: true, dataType: DataType.Numeric },
  {
    columnId: 4,
    header: 'Property Type',
    field: 'property_type',
    sortable: true,
    dataType: DataType.Text,
    displayFn: record => record.property_type.map(pt => getPropertyTypeLabel(pt)).join(', '),
  },
  { columnId: 5, header: 'Market', field: 'markets', sortable: true, dataType: DataType.Text },
  { columnId: 6, header: 'Publishing Sector', field: 'publishing_sector', sortable: true, dataType: DataType.Text },
  { columnId: 6, header: 'Publishing Group', field: 'publishing_group', sortable: true, dataType: DataType.Text },
  {
    columnId: 7,
    header: 'Shared With',
    field: 'permissions',
    sortable: false,
    dataType: DataType.Text,
    // To be used by the cbre-table component
    displayFn: value => {
      return countUsersAndGroups(value);
    },
  },
  {
    columnId: 8,
    header: 'Created By',
    field: 'create_by',
    sortable: true,
    dataType: DataType.Text,
    // To be used by the cbre-table component
    sortDataTransformerFn: toLowerCaseOrEmpty,
  },
  { columnId: 8, header: 'Created On', field: 'create_ts', sortable: true, dataType: DataType.Timestamp },
  {
    columnId: 9,
    header: 'Updated By',
    field: 'update_by',
    sortable: true,
    dataType: DataType.Text,
    // To be used by the cbre-table component
    sortDataTransformerFn: toLowerCaseOrEmpty,
  },
  { columnId: 10, header: 'Updated On', field: 'update_ts', sortable: true, dataType: DataType.Timestamp },
];
